/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeStaffListCtrl
 */
angular.module('mercury.modules.time.staff')
.controller('TimeStaffListCtrl', ["dialog", "$filter", "$scope", "TimeStaff", "title", "userinfo", function(dialog, $filter, $scope, TimeStaff, title, userinfo) {
  title.set('Manage Staff Members');

  $scope.filterName = '';
  $scope.filterDeleted = false;
  $scope.filteredStaff = [];

  $scope.staffLoading = TimeStaff.getAll();
  $scope.staffLoading.then(function(staff) {
    $scope.staff = staff;
    $scope.updatedFilteredStaff();
  });

  $scope.updatedFilteredStaff = function() {
    $scope.filteredStaff = $filter('filter')($scope.staff, function(member) {
      var matchStringFilter = $scope.filterName === '' || member.name.toLowerCase().indexOf($scope.filterName.toLowerCase()) != -1 ||
        member.defaultMemberRoleRoleName.toLowerCase().indexOf($scope.filterName.toLowerCase()) != -1;

      var matchDeletedFilter = (member.datestampDeleted !== null) == $scope.filterDeleted;

      return matchStringFilter && matchDeletedFilter;
    });
  };

  $scope.tableColumns = userinfo.companyHasPermission('Payroll') ? 6 : 5;
  $scope.salaryPermission = userinfo.companyHasPermission('Salary');

  $scope.staffAdded = function(newStaff) {
    $scope.staff.push(newStaff);
    $scope.updatedFilteredStaff();
  };

  $scope.addFromPos = function() {
    dialog.open({
      templateUrl: 'modules/time/staff/addpos.tpl.html',
      controller: 'TimeStaffAddPosCtrl'
    });
  };

  $scope.addFromPosBulk = function() {
    dialog.open({
      templateUrl: 'modules/time/staff/addposbulk.tpl.html',
      controller: 'TimeStaffAddPosBulkCtrl',
      size: 'lg',
      scope: $scope
    });
  };

  $scope.exportToPayroll = function() {
    dialog.open({
      templateUrl: 'modules/time/staff/export.tpl.html',
      controller: 'TimeStaffExportCtrl',
      scope: $scope
    });
  };

  $scope.inlineUpdate = function(updatedStaff) {
    angular.forEach($scope.staff, function(staff, index) {
      if (staff.id == updatedStaff.id) {
        $scope.staff.splice(index, 1, updatedStaff);
      }
    });
    $scope.updatedFilteredStaff();
  };

  /**
   * Gets the default role of a staff member
   * @param {*} staffMember teh staff member
   * @returns the staff members default role
   */
  var getDefaultRole = function(staffMember) {
    var defaultRoleId = staffMember.defaultRoleId;
    return staffMember.memberRoles.find(function(role) {
      return role.roleId == defaultRoleId;
    });
  };

  /**
   * Gets the staff members full name (The PUT response model has changed as of 4/12/23 so need to cater for this)
   * @param {*} staffMember the staff member
   * @returns the staff members full name
   */
  $scope.getName = function(staffMember) {
    return staffMember.name ? staffMember.name : staffMember.firstName + ' ' + staffMember.lastName;
  };

  /**
   * Gets the staff members default role (The PUT reponse model has chnages as of 4/12/23 so need to cater for this)
   * @param {*} staffMember the staff member
   * @returns the staff members default role
   */
  $scope.getDefaultRole = function(staffMember) {
    if (staffMember.defaultMemberRoleRoleName) {
      return staffMember.defaultMemberRoleRoleName;
    }

    var defaultRole = getDefaultRole(staffMember);

    return defaultRole.role.name;
  };

  /**
   * Gets the staff members default role's hourly rate (The PUT reponse model has chnages as of 4/12/23 so need to cater for this)
   * @param {*} staffmember the staff member
   * @returns the staff members default role's hourly rate
   */
  $scope.getDefaultHourlyRate = function(staffMember) {
    if (staffMember.defaultMemberRoleHourlyRate || staffMember.defaultMemberRoleHourlyRate === 0) {
      return staffMember.defaultMemberRoleHourlyRate;
    }

    var defaultRole = getDefaultRole(staffMember);

    return defaultRole.hourlyRate;
  };
}]);
